import { combineReducers } from 'redux';

import containerReducer from './ducks/container';
import queryReducer from './ducks/query';
import columnsReducer from './ducks/columns';


const reducers = {
  container: containerReducer,
  columns: columnsReducer,
  query: queryReducer,
};

export default combineReducers(reducers);
